module.exports = __webpack_public_path__ + "img/logoCtis.7bc0b1e7.svg";